var integrations = require('integrations/search');

integrations.baseFiles.search = require('./search/search');

module.exports = integrations;
